import { Injectable } from "@angular/core";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { BaseJWTService } from "@apps/patient-core/src/app/services/abstracts/jwt.service";
import { isOnUnsupportedPage } from "@apps/patient-core/src/app/utils/unsupported";

dayjs.extend(advancedFormat);

@Injectable({
  providedIn: "root",
})
export class PatientJWTService extends BaseJWTService {
  public get isRestricted(): boolean {
    const { restricted_mode } = this._getParsedJWT() || {};

    // This can be a string or a boolean depending on whether the JWT was create for a short code or the patient has logged in
    // AWS converts all data to strings when it's passed from the JWT authorizer to the lambda function
    return restricted_mode === true || restricted_mode === "true";
  }

  public handleInvalidToken(reload = true): void {
    this.onInvalidJWT.next();

    if (this._locationService.isRootDomain) {
      this._cacheService.clearSession();
      this._cacheService.clear();
    } else {
      this.delete();
    }

    if (!reload || isOnUnsupportedPage()) {
      return;
    }

    // If the route has params, we want to reload the page so that the route can be handled correctly
    // Routes with params include site direct links (/practices/alias) and short codes (/r/short-code)
    // Because this could be triggered in the app init flow, we need to wait for the route to be activated
    this._routeService.activatedSnapshot.subscribe(({ params }) => {
      if (Object.keys(params).length) {
        this._windowService.reload();
      } else {
        this._windowService.open("/");
      }
    });
  }

  public setToken(jwt: string) {
    super.setToken(jwt);
  }
}
